// extracted by mini-css-extract-plugin
module.exports = {"root":"ChipInput_root__3WZLp"};